import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { ProductsProvider } from "./context/ProductsContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { CookieBanner } from "./components/CookieBanner";
import Home from "./pages/Home";
import ProductPage from "./pages/ProductPage";
import Contact from "./pages/Contact";
import Termeni from "./pages/Termeni";
import Confidentialitate from "./pages/Confidentialitate";
import Cookies from "./pages/Cookies";
import Retur from "./pages/Retur";
import Livrare from "./pages/Livrare";
import Garantie from "./pages/Garantie";
import Admin from "./pages/Admin";
import useTrackPageView from "./hooks/useTrackPageView";

function PageTracker() {
  useTrackPageView();
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-white text-slate-900 font-body">
      <BrowserRouter>
        <ProductsProvider>
          <CartProvider>
            <PageTracker />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produs/:slug" element={<ProductPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/termeni-conditii" element={<Termeni />} />
            <Route path="/politica-confidentialitate" element={<Confidentialitate />} />
            <Route path="/politica-cookies" element={<Cookies />} />
            <Route path="/politica-retur" element={<Retur />} />
            <Route path="/politica-livrare" element={<Livrare />} />
            <Route path="/politica-garantie" element={<Garantie />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <CartDrawer />
          <WhatsAppFloat />
          <CookieBanner />
          <Toaster
            position="bottom-center"
            richColors
            toastOptions={{
              style: {
                fontFamily: "DM Sans, sans-serif",
              },
            }}
          />
        </CartProvider>
        </ProductsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
